// frontend/src/config.js

// Zet dit tijdelijk op true om de native app te laten praten met de backend
// die lokaal op je laptop draait (zelfde wifi-netwerk nodig) - handig tijdens
// ontwikkelen/testen van nieuwe features. Voor normaal gebruik (en voor de
// versie die je naar de App Store / Play Store stuurt) moet dit op false
// staan, zodat de app altijd de live server op smartstays.be gebruikt.
const USE_LOCAL_BACKEND = false;

// Vind je IP via terminal: ipconfig getifaddr en0
// Belangrijk: dit kan wijzigen als je router een nieuw IP toewijst - check
// dit opnieuw als de app in native modus (met USE_LOCAL_BACKEND op true) geen
// contact meer krijgt met de API.
const YOUR_IP = '192.168.0.218'; // Vervang door jouw IP-adres

const PRODUCTION_DOMAIN = 'https://smartstays.be';

const isNativeApp = () => {
  if (window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function') {
    return window.Capacitor.isNativePlatform();
  }
  return false;
};

const getApiUrl = () => {
  // Native app: standaard de live server, tenzij je bewust lokaal test.
  if (isNativeApp()) {
    return USE_LOCAL_BACKEND ? `http://${YOUR_IP}:3000` : PRODUCTION_DOMAIN;
  }
  // Productie-build (npm run build, zoals op de VPS): Nginx draait op
  // dezelfde origin (https) en stuurt "/api" intern door naar de backend.
  // Daarom hier relatieve paden gebruiken - geen apart poortnummer, en geen
  // "mixed content"-fout zodra https actief is.
  if (process.env.NODE_ENV === 'production') {
    return '';
  }
  // Lokale ontwikkeling (npm start): frontend en backend draaien op aparte
  // poorten, dus expliciet hetzelfde adres als waarmee de site zelf geopend
  // is + poort 3000 gebruiken. Zo werkt dit zowel via "localhost" als via
  // het IP-adres van je laptop (bv. vanaf je telefoon op hetzelfde
  // wifi-netwerk).
  return `http://${window.location.hostname}:3000`;
};

const API_URL = getApiUrl();

console.log('API_URL:', API_URL); // Debug: check in browser/logcat console

export default API_URL;